import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, FileText } from 'lucide-react';

/**
 * Sticky bottom CTA bar — visible only on mobile (md and below).
 * Hidden on the Contact page to avoid covering the main quote form.
 */
const MobileStickyCTA = () => {
  const { pathname } = useLocation();
  if (pathname === '/contact') return null;

  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-gray-200 shadow-2xl"
      data-testid="mobile-sticky-cta"
    >
      <div className="grid grid-cols-2 gap-0">
        <a
          href="tel:+17063663685"
          className="flex items-center justify-center py-4 bg-green-800 text-white font-semibold text-sm hover:bg-green-900 transition-colors"
          data-testid="mobile-cta-call"
        >
          <Phone className="w-5 h-5 mr-2" />
          Call Now
        </a>
        <Link
          to="/contact"
          className="flex items-center justify-center py-4 bg-gray-900 text-white font-semibold text-sm hover:bg-gray-800 transition-colors"
          data-testid="mobile-cta-quote"
        >
          <FileText className="w-5 h-5 mr-2" />
          Request Quote
        </Link>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
